import React from 'react'
import { Placeholder } from './AvatarPlaceholder.styles'

const AvatarPlaceholder = ({ userName = '' }: { userName: string }) => {
  const userInitials = userName
    .split(' ')
    .map(name => name.slice(0, 1))
    .slice(0, 2)
    .join('')

  return (
    <Placeholder align="center" justify="center">
      {userInitials}
    </Placeholder>
  )
}

export default AvatarPlaceholder
